import { render } from "./AccountDeletion.vue?vue&type=template&id=72c9ec18&scoped=true"
import script from "./AccountDeletion.vue?vue&type=script&lang=js"
export * from "./AccountDeletion.vue?vue&type=script&lang=js"

import "./AccountDeletion.vue?vue&type=style&index=0&id=72c9ec18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c9ec18"]])

export default __exports__